<header class="page-header">
  <div>
    <h1 class="page-title">{{ 'pages.applications.title' | translate }}</h1>
    <p class="page-subtitle">{{ 'pages.applications.subtitle' | translate }}</p>
  </div>

  <button class="btn btn-primary" type="button" (click)="requestCreate()">
    <i class="fa-solid fa-plus" aria-hidden="true"></i>
    {{ 'pages.applications.actions.create' | translate }}
  </button>
</header>
